export const PROMO_CODE_ADMIN_LIST_REQUEST =
  "PROMO_CODE_ADMIN_LIST_REQUEST";
export const PROMO_CODE_ADMIN_LIST_SUCCESS =
  "PROMO_CODE_ADMIN_LIST_SUCCESS";
export const PROMO_CODE_ADMIN_LIST_FAIL = "PROMO_CODE_ADMIN_LIST_FAIL";

export const PROMO_CODE_DETAILS_REQUEST = "PROMO_CODE_DETAILS_REQUEST";
export const PROMO_CODE_DETAILS_SUCCESS = "PROMO_CODE_DETAILS_SUCCESS";
export const PROMO_CODE_DETAILS_FAIL = "PROMO_CODE_DETAILS_FAIL";

export const PROMO_CODE_CREATE_REQUEST = "PROMO_CODE_CREATE_REQUEST";
export const PROMO_CODE_CREATE_SUCCESS = "PROMO_CODE_CREATE_SUCCESS";
export const PROMO_CODE_CREATE_FAIL = "PROMO_CODE_CREATE_FAIL";
export const PROMO_CODE_CREATE_RESET = "PROMO_CODE_CREATE_RESET";

export const PROMO_CODE_UPDATE_REQUEST = "PROMO_CODE_UPDATE_REQUEST";
export const PROMO_CODE_UPDATE_SUCCESS = "PROMO_CODE_UPDATE_SUCCESS";
export const PROMO_CODE_UPDATE_FAIL = "PROMO_CODE_UPDATE_FAIL";
export const PROMO_CODE_UPDATE_RESET = "PROMO_CODE_UPDATE_RESET";

export const PROMO_CODE_DELETE_REQUEST = "PROMO_CODE_DELETE_REQUEST";
export const PROMO_CODE_DELETE_SUCCESS = "PROMO_CODE_DELETE_SUCCESS";
export const PROMO_CODE_DELETE_FAIL = "PROMO_CODE_DELETE_FAIL";
export const PROMO_CODE_DELETE_RESET = "PROMO_CODE_DELETE_RESET";
